import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const useDataExtractionMismatchAlertFlag = (): boolean =>
  useBooleanFlagValue('data-extraction-mismatch-alert', false);
